const getDefaultState = () => {
    return {
        account: {
            name: null,
            sellsy_id: null,
            timezone: null,
        },
        subscription: {
            valid_from: null,
            valid_through: null,
            value: null
        },
        modules: [],
        admin: {
            first_name: null,
            last_name: null,
            email: null
        },
        currentStep: 1,
        editMod: false,
        configs: []
    }
}

const createAccount = {
    namespaced: true,
    state: getDefaultState(),
    mutations: {
        setCurrentStep(state, value) {
            state.currentStep = value
        },
        setAccount(state, value) {
            state.account = value
        },
        setAccountName(state, value) {
            state.account.name = value
        },
        setAccountSellsyId(state, value) {
            state.account.sellsy_id = value
        },
        setAccountTimezone(state, value) {
            state.account.timezone = value
        },
        setSubscription(state, value) {
            state.subscription = value
        },
        setSubscriptionValidFrom(state, value) {
            state.subscription.valid_from = value
        },
        setSubscriptionValidThrough(state, value) {
            state.subscription.valid_through = value
        },
        setSubscriptionValidValue(state, value) {
            state.subscription.value = value
        },
        setAdminFirstName(state, value) {
            state.admin.first_name = value
        },
        setAdminLastName(state, value) {
            state.admin.last_name= value
        },
        setAdminEmail(state, value) {
            state.admin.email = value
        },
        setModules(state, value) {
            state.modules = value
        },
        addModule(state, value) {
            state.modules.push(value)
        },
        setEditMod(state, value) {
            state.editMod = value
        },
        setConfigs(state, value) {
            state.configs = value
        },
        updateConfig(state, config) {
            state.configs.forEach(accountConfig => {
                if(accountConfig.key === config.key) {
                    accountConfig.value = config.value
                }
            })
        },
        resetState(state) {
            Object.assign(state, getDefaultState())
        }
    }
}

export default createAccount